import React, { useState, useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, IconButton, Button } from '@material-ui/core';
import _ from 'lodash';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';

export function CustomTable({ tableData }) {
  const cloneData = _.cloneDeep(tableData);
  const data = cloneData.map((obj) => ({
    ...obj,
    shortSupplyAmount: obj.quantity - obj.fulfilledQuantity < 0 ? 0 : obj.quantity - obj.fulfilledQuantity
  }));

  const columns = useMemo(
    () => [
      {
        accessorKey: 'productCode',
        header: 'SKU',
        size: 100
      },
      {
        accessorKey: 'proName',
        header: 'Crop Name',
        size: 100
      },
      {
        accessorKey: 'quantity',
        header: 'Quantity',
        size: 100,
        muiTableHeadCellProps: {
          align: 'right'
        },
        muiTableBodyCellProps: {
          align: 'right'
        },
        Cell: ({ cell }) => parseFloat(cell.getValue()).toFixed(3)
      },
      {
        accessorKey: 'fulfilledQuantity',
        header: 'Fulfilled Quantity',
        size: 100,
        muiTableHeadCellProps: {
          align: 'right'
        },
        muiTableBodyCellProps: {
          align: 'right'
        },
        Cell: ({ cell }) => parseFloat(cell.getValue()).toFixed(3)
      },
      {
        accessorKey: 'shortSupplyAmount',
        header: 'Short Supply',
        size: 100,
        muiTableHeadCellProps: {
          align: 'right'
        },
        muiTableBodyCellProps: {
          align: 'right'
        },
        Cell: ({ cell }) => parseFloat(cell.getValue()).toFixed(3)
      },
      {
        accessorKey: 'measuringUnitName',
        header: 'Measuring Unit',
        size: 100,
        muiTableHeadCellProps: {
          align: 'right'
        },
        muiTableBodyCellProps: {
          align: 'right'
        }
      }
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data
  });

  return (
    <div>
      <MaterialReactTable
        columns={columns}
        data={data}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableColumnActions={false}
        initialState={{ density: 'compact', showGlobalFilter: true }}
      />
    </div>
  );
}
